import { all, fork } from 'redux-saga/effects';
import TeamsSaga from './teamsSaga';
import LoginSaga from './loginSaga';
import CustomerSaga from './customerSaga';
import CusTeamsSaga from './cusTeamsSaga';
import ResetPassSaga from './resetPassSaga';
import dashBoardSaga from './dashBoardSaga';
import ForgetPassSaga from './forgetPassSaga';
import moderationSaga from './moderationSaga';
import AppReleaseSaga from './appReleaseSaga';
import profileUpdateSaga from './profileUpdateSaga';
import ChangePasswordSaga from './ChangePasswordSaga';
import activityLogSaga from './activityLogSaga';

export default function* rootSaga() {
    yield all([
        fork(TeamsSaga),//TeamsPage(list.addMember)
        fork(LoginSaga),//login
        fork(CustomerSaga),//customer(list,addCustomer)
        fork(CusTeamsSaga),//app release
        fork(ResetPassSaga),//Reset
        fork(dashBoardSaga),//dashBoard release
        fork(ForgetPassSaga),//Forget
        fork(AppReleaseSaga),//app release
        fork(moderationSaga),//moderation list
        fork(profileUpdateSaga),//profileUpdate
        fork(ChangePasswordSaga),//change password
        fork(activityLogSaga),//activitylog list
    ]);
}
